import { render, staticRenderFns } from "./BookingPage.vue?vue&type=template&id=526a23dc&"
import script from "./BookingPage.vue?vue&type=script&lang=ts&"
export * from "./BookingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports